'use strict';

var jsonSchema_utils = require('./utils.js');
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var ParameterTypeSchema = /*#__PURE__*/function () {
  function ParameterTypeSchema() {
    _classCallCheck(this, ParameterTypeSchema);
  }
  return _createClass(ParameterTypeSchema, null, [{
    key: "generateSchemaByType",
    value: function generateSchemaByType(type) {
      if (type === 'file') {
        return {
          format: 'binary',
          type: 'string'
        };
      } else if (type === 'array') {
        return {
          type: 'array',
          items: {
            type: 'string'
          }
        };
      } else {
        return {
          type: type
        };
      }
    }
  }, {
    key: "getTypeBySchema",
    value: function getTypeBySchema(schema, stringBinaryToFile) {
      var newSchema = schema !== null && schema !== void 0 ? schema : {};
      var result = jsonSchema_utils.getMainType(newSchema);
      if (stringBinaryToFile && result === 'string' && newSchema.format === 'binary') {
        result = 'file';
      }
      return result;
    }
  }, {
    key: "getOldTypeBySchema",
    value: function getOldTypeBySchema(schema) {
      var supportTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['string', 'integer', 'boolean', 'number', 'array'];
      var stringBinaryToFile = arguments.length > 2 ? arguments[2] : undefined;
      var resultType = 'string';
      var mainType = jsonSchema_utils.getMainType(schema !== null && schema !== void 0 ? schema : {});
      if (supportTypes.includes(mainType)) {
        resultType = mainType;
      } else if (['ref', 'object', 'any', 'null', 'oneOf', 'anyOf', 'allOf', 'not', 'other'].includes(mainType)) {
        resultType = 'other';
      }
      if (stringBinaryToFile && resultType === 'string' && (schema === null || schema === void 0 ? void 0 : schema.format) === 'binary') {
        resultType = 'file';
      }
      return resultType;
    }
  }, {
    key: "parameterToSchema",
    value: function parameterToSchema(parameter, stringBinaryToFile) {
      if (!parameter.schema) {
        var _parameter$type;
        return ParameterTypeSchema.generateSchemaByType((_parameter$type = parameter.type) !== null && _parameter$type !== void 0 ? _parameter$type : 'string');
      }
      var schemaToType = ParameterTypeSchema.getTypeBySchema(parameter.schema, stringBinaryToFile);
      if (parameter.type !== 'other' && parameter.type !== schemaToType) {
        return ParameterTypeSchema.generateSchemaByType(parameter.type);
      }
      return parameter.schema;
    }
  }, {
    key: "parameterToDocViewSchema",
    value: function parameterToDocViewSchema(parameter) {
      var isCommonParameter = 'isCommonParameter' in parameter && parameter.isCommonParameter;
      var schema = _objectSpread({}, ParameterTypeSchema.parameterToSchema(parameter));
      if (parameter.type === 'file') {
        if ([schema.type].flat().includes('null')) {
          schema.type = ['string', 'null'];
        } else {
          schema.type = 'file';
        }
      }
      if (parameter.example !== undefined && parameter.example !== '') {
        schema.example = parameter.example;
      }
      if (schema.example === '') {
        delete schema.example;
      } else if (schema.example !== undefined) {
        delete schema.examples;
      }
      if (parameter.description) {
        schema.description = parameter.description;
      }
      if (typeof parameter.deprecated === 'boolean') {
        schema.deprecated = parameter.deprecated;
      }
      if (isCommonParameter && 'defaultValue' in parameter) {
        schema.isCommonParameter = true;
        if (parameter.defaultValue || typeof parameter.defaultValue === 'boolean' || typeof parameter.defaultValue === 'number') {
          schema["default"] = parameter.defaultValue;
        }
      }
      return schema;
    }
  }]);
}();
exports.ParameterTypeSchema = ParameterTypeSchema;
